import { render } from "./calendar-list.vue?vue&type=template&id=0704cd38"
import script from "./calendar-list.vue?vue&type=script&lang=js"
export * from "./calendar-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__